<template>
  <form-wrap
    class="new-password-form"
    @submit="handleSubmit"
  >
    <form-field-set :should-show-border="false">
      <text-input
        v-model="password"
        :error="fieldError('update', 'password')"
        :label="$t('c.newPasswordForm.form.label.newPassword')"
        name="password"
        direction="vertical"
        type="password"
      />

      <text-input
        v-model="passwordConfirmation"
        :error="fieldError('update', 'passwordConfirmation')"
        :label="$t('c.newPasswordForm.form.label.newPasswordConfirmation')"
        name="passwordConfirmation"
        direction="vertical"
        type="password"
      >
        <security-indicator
          slot="addon"
          :percent="percentNumber"
          class="password-indicator"
        />
      </text-input>
    </form-field-set>
    <form-actions>
      <button-input
        v-t="'c.newPasswordForm.form.action.submit'"
        :is-disabled="!isValid"
        type="submit"
      />
      <router-link
        v-t="'c.newPasswordForm.form.action.signin'"
        :to="{ name: 'SignInPage' }"
      />
    </form-actions>
  </form-wrap>
</template>

<script>
import {
  NOTIFICATION_TYPE_SUCCESS,
  NOTIFICATION_TYPE_ERROR
} from 'store/modules/notifications/types'
import zxcvbn from 'zxcvbn'
import SecurityIndicator from '@/components/forms/SecurityIndicator'
import FormMixin from '@/mixins/forms/Form'
import { mapActions, mapGetters } from 'vuex'
import get from 'just-safe-get'

export default {
  name: 'NewPasswordForm',
  mixins: [FormMixin],
  components: {
    SecurityIndicator
  },
  computed: {
    ...mapGetters({
      fieldError: 'newPasswordForm/fieldError',
      isValid: 'newPasswordForm/isValid'
    }),
    password: {
      get () { return this.$store.state.newPasswordForm.form.password },
      set (value) { this.$store.dispatch('newPasswordForm/setPassword', value) }
    },
    passwordConfirmation: {
      get () { return this.$store.state.newPasswordForm.form.passwordConfirmation },
      set (value) { this.$store.dispatch('newPasswordForm/setPasswordConfirmation', value) }
    },
    score () {
      return zxcvbn(this.password).score
    },
    percentNumber () {
      return this.score > 0
        ? this.score * 25
        : 0
    }
  },
  methods: {
    ...mapActions({
      submit: 'newPasswordForm/customSubmit',
      reset: 'newPasswordForm/reset'
    }),
    ...mapActions([
      'addNotification'
    ]),
    handleSubmit () {
      this.submit()
        .then(() => {
          this.addNotification({
            message: 'Ihr Passwort wurde erfolgreich geändert, melden Sie sich mit ihrem neuen Passwort an.',
            type: NOTIFICATION_TYPE_SUCCESS
          })
          this.$router.push({ name: 'SignInPage' })
        })
        .catch(error => {
          const statusCode = get(error, 'response.status')

          switch (statusCode) {
            case 404:
              this.addNotification({
                message: 'Der Token ist ungültig, bitte beantrage erneuet ein neues Passwort.',
                type: NOTIFICATION_TYPE_ERROR
              })
              break
            case 422:
              break
            default:
              this.addNotification({
                message: 'Etwas ist schief gelaufen. Bitte versuchen Sie es später erneut oder kontaktieren Sie uns.',
                type: NOTIFICATION_TYPE_ERROR
              })
          }
        })
    }
  },
  created () {
    const token = this.$route.params.token
    this.$store.dispatch('newPasswordForm/setToken', token)
  },
  beforeDestroy () {
    this.reset()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/auth/NewPasswordForm.vue